<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-26 17:21:59
 * @LastEditTime: 2022-03-24 14:09:50
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog :title="type === 'edit'
      ? $t('lang.editVar.Editvariables')
      : $t('lang.editVar.addvariable')
      " center :visible.sync="dialogVisible" append-to-body>
      <div class="params-form">
        <el-form :model="paramsForm" ref="paramsForm" :rules="rules" label-position="right" label-width="180px">
          <el-form-item :label="$t('lang.editVar.type')" prop="type">
            <el-input :value="typeListObj[templateType]" size="mini" class="form-input" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.variableName')" prop="name">
            <el-input size="mini" v-model="paramsForm.name" class="form-input"></el-input>
          </el-form-item>
          <el-form-item v-if="templateType == 1" :label="$t('lang.collect.IOcontrollertype')" prop="ioType">
            <el-select clearable size="mini" @change="typeChange" class="form-input"
              :value="ioTypeObj[paramsForm.ioType]">
              <el-option v-for="item in ioTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.interfacenumber')" prop="ioNumber" v-if="templateType == 1">
            <el-select :value="ioNumberObj[paramsForm.ioNumber]" @change="ioNumberChange" class="form-input"
              size="mini">
              <el-option v-for="item in ioNumberList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="templateType == 0" :label="$t('lang.collect.registertype')" prop="registerType">
            <el-select clearable size="mini" class="form-input" v-model="paramsForm.registerType">
              <el-option v-for="item in registerTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <span style="margin-left: 5px; color: #409eff">{{
              computedRorw
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('lang.editVar.rawtype')" prop="isAlter">
            <el-select class="form-input" @change="isAlterChange" :value="isAlterObj[paramsForm.isAlter]" size="mini">
              <el-option v-for="item in isAlterList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 从站id -->
          <el-form-item v-if="templateType == 0" :label="$t('lang.terminalList.SlaveID')" prop="sid">
            <el-input size="mini" type="number" v-model="paramsForm.sid" class="form-input"></el-input>
            <p style="line-height: 1em;font-size: 12px;color: rgb(153, 153, 153);">
              {{ $t('lang.terminalList.Valuerange') }}255</p>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.functiontype')" prop="funcType" v-if="templateType == 1">
            <el-select size="mini" :value="ioControlListObj[paramsForm.funcType]" @change="functypeChange"
              class="form-input">
              <el-option v-for="item in ioControlListOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.functiontype')" prop="funcType" v-if="
            templateType == 0 &&
            paramsForm.registerType != 1 &&
            paramsForm.registerType != 2
          ">
            <el-select size="mini" :value="modbusListObj[paramsForm.funcType]" @change="functypeChange"
              class="form-input">
              <el-option v-for="item in modbusListOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.editVar.variableunit')" v-if="
            !unitNoShowItem.includes(this.paramsForm.registerType) &&
            templateType == 0 &&
            paramsForm.registerType != 1 &&
            paramsForm.registerType != 2 && paramsForm.dataType != 10
          ">
            <el-select size="mini" :value="unitObj[paramsForm.unit]" @change="uintChange" class="form-input">
              <el-option v-for="item in unitOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="templateType == 0" :label="$t('lang.collect.startaddress')" prop="registerAddress">
            <div style="display: flex">
              <div style="display: flex; flex-direction: column">
                <el-input size="mini" clearable v-model="paramsForm.registerAddress" class="form-input"
                  type="number"></el-input>
                <span style="line-height: 1em; font-size: 12px; color: #999">{{
                  $t("lang.editVar.inputrange")
                }}</span>
              </div>
              <span style="margin-left: 5px; color: #409eff">{{
                computedAddress
              }}</span>
            </div>
          </el-form-item>

          <el-form-item v-if="templateType == 0" :label="$t('lang.editVar.typedata')" prop="dataType">
            <el-select clearable size="mini" class="form-input" v-model="paramsForm.dataType">
              <el-option v-for="item in computedDataType" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.endian')" prop="endian" v-if="
            endianEable.includes(this.paramsForm.dataType) &&
            templateType == 0
          ">
            <el-select clearable size="mini" class="form-input" v-model="paramsForm.endian">
              <el-option v-for="item in endianOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.Reportingtype')" prop="trigger">
            <el-select clearable size="mini" class="form-input" v-model="paramsForm.trigger">
              <el-option v-for="item in triggerOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.Reportingcycle')" prop="interval"
            v-if="intervalEnable.includes(this.paramsForm.trigger)">
            <el-select class="form-input" size="mini" filterable allow-create default-first-option
              :placeholder="$t('lang.editVar.reportingperiod')" v-model="paramsForm.interval" @change="intervalChange"
              clearable>
              <el-option v-for="item in intervalOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <span style="margin-left: 5px; color: grey">{{
              $t("lang.collect.second")
            }}</span>
            <!-- <el-input size="mini" placeholder="请输入上报周期" v-model="paramsForm.interval" clearable></el-input> -->
          </el-form-item>
          <!-- 计算因子暂时用不上，先隐藏 -->
          <el-form-item :label="$t('lang.collect.calculationfactor')" prop="factor" v-if="
            !factorNoShowItem.includes(this.paramsForm.registerType) &&
            templateType == 0
          ">
            <el-input class="form-input" size="mini" :placeholder="$t('lang.editVar.calculationfactor')"
              v-model="paramsForm.factor" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="变量类型：" prop="dataFormat">
            <el-select clearable size="mini" class="form-input" v-model="paramsForm.dataFormat">
              <el-option 
                v-for="item in dataFormateOptions" 
                :key="item.value" 
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="寄存器个数：" prop="registerNum">
            <el-input-number size="mini" v-model="paramsForm.registerNum" :min="0"></el-input-number>
          </el-form-item>-->
          <el-form-item :label="$t('lang.editVar.decimalprecision')" prop="precision" v-if="
            precisionShowItem.includes(paramsForm.dataType) &&
            templateType == 0
          ">
            <el-input size="mini" v-model="paramsForm.precision" class="form-input"></el-input>
          </el-form-item>
          <!-- <el-form-item label="IO口状态：" prop="state" v-if="templateType == 1">
            <el-select :value="ioStateObj[paramsForm.state]" size="mini">
              <el-option v-for="item in ioStateOptions" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="存储方式：" prop="storageMode">
            <el-radio-group v-model="paramsForm.storageMode">
              <el-radio :label="1">变化存储</el-radio>
              <el-radio :label="2">全部存储</el-radio>
            </el-radio-group>
          </el-form-item>-->
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.collect.Cancel")
        }}</el-button>
        <el-button size="mini" @click="submitForm" type="primary">{{
          $t("lang.collect.msg3")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  registerTypeOptions,
  dataFormateOptions,
  dataTypeOptions,
  endianOptions,
  ioTypeOptions,
  ioTypeObj,
  ioStateObj,
  ioStateOptions,
  triggerOptions,
  unitOptions,
  unitObj,
  intervalOptions,
  typeListOptions,
  modbusListOptions,
  modbusListObj,
  typeListObj,
  ioControlListOptions,
  ioControlListObj,
} from "@/utils/paramsConfig";
import { addParams, editParams } from "@/api/cloudMonitor/paramsList";
import { cloneDeep, isEqual } from "lodash";
export default {
  data() {
    // 计算因子验证
    var factorCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("lang.editVar.msg1")));
      } else if (value == 0) {
        callback(new Error(this.$t("lang.editVar.msg2")));
      } else if (isNaN(Number(value))) {
        callback(new Error(this.$t("lang.editVar.msg3")));
      } else {
        callback();
      }
    };
    var registerAddressCheck = (rule, value, callback) => {
      if (value === "" || parseInt(value) > 65535 || parseInt(value) < 0) {
        callback(new Error(this.$t("lang.editVar.msg4")));
      } else {
        callback();
      }
    };
    var sidCheck = (rule, value, callback) => {
      if (value === "" || parseInt(value) > 255 || parseInt(value) < 0) {
        callback(new Error(this.$t("lang.editVar.msg30")));
      } else {
        callback();
      }
    };
    return {
      ioTypeOptions,
      ioStateObj,
      ioStateOptions,
      ioTypeObj,
      dialogVisible: false,
      type: "", //编辑还是添加
      templateId: "", // 采集模板Id
      registerTypeOptions, // 寄存器类型选项
      dataFormateOptions, //变量类型选项
      dataTypeOptions, //数据类型选项
      endianOptions, //字节序选项
      triggerOptions, //上报类型数组
      unitOptions, // 变量单位数组
      intervalOptions,
      unitObj,
      modbusListOptions,
      modbusListObj,
      typeListOptions,
      ioControlListObj,
      ioControlListOptions,
      typeListObj,
      intervalEnable: [2, 4], // 符合设置上报周期的上报类型选项
      endianEable: [3, 4, 5, 6, 7, 8, 12], // 符合设置字节序的数据类型选项
      precisionShowItem: [7, 8], // 符合显示精度表单项的数据类型
      unitNoShowItem: [1, 2], // 变量单位显示寄存器类型白名单
      factorNoShowItem: [1, 2], // 计算因子寄存器类型白名单
      rules: {
        funcType: [
          {
            required: true,
            message: this.$t("lang.editVar.msg5"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("lang.editVar.msg6"),
            trigger: "blur",
          },
        ],
        registerType: [
          {
            required: true,
            message: this.$t("lang.editVar.msg7"),
            trigger: ["blur", "change"],
          },
        ],
        sid: [
          {
            required: true,
            message: this.$t("lang.editVar.msg30"),
            trigger: ["blur", "change"],
            validator: sidCheck,
          },
        ],
        dataFormat: [
          {
            required: true,
            message: this.$t("lang.editVar.msg8"),
            trigger: ["blur", "change"],
          },
        ],
        // unit: [
        //   {
        //     required: true,
        //     message: this.$t("lang.editVar.msg9"),
        //     trigger: "blur",
        //   },
        // ],
        registerAddress: [
          {
            required: true,
            message: this.$t("lang.editVar.msg10"),
            validator: registerAddressCheck,
            trigger: ["change"],
          },
        ],
        precision: [
          {
            required: true,
            message: this.$t("lang.editVar.msg11"),
            trigger: "blur",
          },
        ],
        dataType: [
          {
            required: true,
            message: this.$t("lang.editVar.msg12"),
            trigger: ["blur", "change"],
          },
        ],
        endian: [
          {
            required: true,
            message: this.$t("lang.editVar.msg13"),
            trigger: ["blur"],
          },
        ],
        trigger: [
          {
            required: true,
            message: this.$t("lang.editVar.msg14"),
            trigger: ["blur", "change"],
          },
        ],
        interval: [
          {
            required: true,
            message: this.$t("lang.editVar.msg15"),
            trigger: "blur",
          },
        ],
        factor: [{ required: true, validator: factorCheck, trigger: "blur" }],
        ioNumber: [
          {
            required: true,
            message: this.$t("lang.editVar.msg16"),
            trigger: "blur",
          },
        ],
      },
      paramsForm: {
        mid: "",
        name: "",
        action: "0",
        ioType: "0", //IO控制器类型
        funcType: "0", //功能类型
        unit: '', // 变量单位
        registerType: 1, //寄存器类型
        registerAddress: 1, // 寄存器地址
        dataFormat: "", // 变量数据类型
        // registerNum: '', // 寄存器个数
        precision: "2", // 小数精度
        // storageMode: '', // 存储方式
        // rorw: 1, // 读写方式
        dataType: 1, // 数据类型
        endian: "", //字节序，当数据类型为int32、uint32、int64、uint64、float、double是才配置这个字段
        trigger: 2, //上报类型
        interval: "10", //上报周期（int）,单位为秒，上报类型为cycle,range,never是才配置这个字段
        // state: '', // IO口状态
        ioNumber: "1", //IO口号码
        isAlter: "1", //读写状态
      },
      copyData: {}, // 判断是否修改
      ioNumberList: [
        { value: "1", label: this.$t("lang.editVar.relay1") },
        { value: "2", label: this.$t("lang.editVar.relay2") },
      ],
      ioNumberObj: {
        "1": this.$t("lang.editVar.relay1"),
        "2": this.$t("lang.editVar.relay2"),
      },
      isAlterList: [],
      isAlterObj: {},
    };
  },
  props: {
    templateType: {
      default: "0",
    },
  },
  filters: {
    uintString(e) {
      unitOptions.forEach((v) => {
        if (v.value == e) {
          return v.label;
        }
      });
    },
  },
  computed: {
    // 计算数据类型，线圈/开关量的数据类型（Coils status，Discrete Inputs）只能是bool，寄存器的数据类型可以是除了bool型外的所有类型
    computedDataType() {
      if (this.unitNoShowItem.includes(this.paramsForm.registerType)) {
        this.paramsForm.dataType = 10;
        return [{ label: this.$t("lang.editVar.bool"), value: 10 }];
      } else {
        // this.paramsForm.dataType =
        //   this.paramsForm.dataType && this.paramsForm.dataType != 10
        //     ? this.paramsForm.dataType
        //     : 1;
        return this.dataTypeOptions;
      }
    },
    // 计算读写方式
    computedRorw() {
      if (
        this.paramsForm.registerType == 1 ||
        this.paramsForm.registerType == 3
      ) {
        return this.$t("lang.editVar.readandwrite");
      } else {
        return this.$t("lang.editVar.read");
      }
    },
    computedAddress() {
      let prefix = "0";
      let str = "00000";
      let type = this.paramsForm.registerType;
      switch (type) {
        case 1:
          str = "00000";
          prefix = "0";
          break;
        case 2:
          str = "10000";
          prefix = "1";
          break;
        case 3:
          str = "40000";
          prefix = "4";
          break;
        case 4:
          str = "30000";
          prefix = "3";
          break;
        default:
          str = "00000";
          prefix = "0";
      }
      let addrStr = this.paramsForm.registerAddress
        ? this.paramsForm.registerAddress.toString()
        : "";
      if (addrStr.length >= 5) {
        return prefix + addrStr;
      } else {
        let l = str.length - addrStr.length;
        return str.slice(0, l) + addrStr;
      }
    },
  },
  methods: {
    // 清空数据
    clearData() {
      this.paramsForm = {
        mid: "",
        name: "",
        funcType: "0",
        // state:'0',
        ioType: "0",
        action: "0",
        unit: '', // 变量单位
        registerType: 1, //寄存器类型
        registerAddress: 1, // 寄存器起始地址
        dataFormat: "", // 变量类型
        // registerNum: '', // 寄存器个数
        precision: "2", // 小数精度
        // storageMode: 1, // 存储方式
        // rorw: 1, // 读写方式
        dataType: 10, // 数据类型
        endian: "", //字节序，当数据类型为int32、uint32、int64、uint64、float、double是才配置这个字段
        trigger: 2, //上报类型
        interval: "10", //上报周期（int）,单位为秒，上报类型为cycle,range,never是才配置这个字段
        factor: "1", // 计算因子
        ioNumber: "1", //IO口号码
        isAlter: "1",
      };
    },
    show(item) {
      this.clearData();
      if (item.id) {
        // 编辑
        // this.paramsForm.mid = id
        this.type = "edit";
        this.paramsForm = cloneDeep(item);
        this.paramsForm.endian =
          this.paramsForm.endian == 0 ? "" : this.paramsForm.endian;
        this.paramsForm.unit = this.paramsForm.unit;
        this.copyData = cloneDeep(this.paramsForm);
      } else if (item) {
        this.paramsForm.mid = item;
        this.type = "add";
      }
      this.dialogVisible = true;
    },
    // 确认
    submitForm() {
      this.$refs.paramsForm.validate((valid) => {
        if (valid) {
          let change = false; // 是否修改过
          if (isEqual(this.copyData, this.paramsForm)) {
            change = false;
          } else {
            change = true;
          }
          if (!this.intervalEnable.includes(this.paramsForm.trigger)) {
            // 不符合配置上报周期的就把上报周期置为空
            this.paramsForm.interval = "";
          }
          if (!this.endianEable.includes(this.paramsForm.dataType)) {
            // 不符合配置字节序的就把上字节序置为空
            this.paramsForm.endian = 0;
          }
          if (!this.precisionShowItem.includes(this.paramsForm.dataType)) {
            this.paramsForm.precision = 0;
          }
          if (this.unitNoShowItem.includes(this.paramsForm.registerType)) {
            this.paramsForm.unit = 0;
          }
          if (this.factorNoShowItem.includes(this.paramsForm.registerType)) {
            this.paramsForm.factor = 1;
          }
          this.$set(this.paramsForm, "sid", Number(this.paramsForm.sid));
          this.$set(this.paramsForm, "type", this.templateType);
          if (this.type === "edit") {
            if (change) {
              editParams(this.paramsForm)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$message.success(this.$t("lang.editVar.msg17"));
                    this.$emit("updateList");
                    // 缓存更改的变量id
                    this.$emit("setParamsIds", this.paramsForm.id);
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(this.$t("lang.editVar.msg18"));
                  }
                })
                .catch(() => { });
            } else {
              this.$message.warning(
                this.$t("lang.ConfigSetting.Nochangesmade")
              );
              this.dialogVisible = false;
            }
          } else {
            addParams(this.paramsForm)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.editVar.msg19"));
                  // 获取添加后的id,并缓存
                  this.$emit("updateList");
                  this.$emit("setParamsIds", res.data.data);
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.$t("lang.editVar.msg20"));
                }
              })
              .catch(() => { });
          }
        } else {
          return false;
        }
      });
    },
    /**
     * select选择框改变时触发
     * @param {*} e
     */
    uintChange(e) {
      if (e == "自定义") {
        this.$prompt(
          this.$t("lang.editVar.Pleaseentertheunit"),
          this.$t("lang.editVar.msg22"),
          {
            confirmButtonText: this.$t("lang.editVar.msg23"),
            cancelButtonText: this.$t("lang.editVar.msg24"),
            inputValidator: (e) => {
              if (!e) {
                return this.$t("lang.editVar.Pleaseentertheunit");
              } else if (e.length > 10) {
                return this.$t("lang.editVar.msg28");
              } else if (e.length == 0) {
                return this.$t("lang.editVar.msg29");
              } else {
                return true;
              }
            },
          }
        ).then((v) => {
          if (v.value) {
            this.unitObj[v.value] = v.value;
            this.unitOptions.splice(this.unitOptions.length - 1, 0, {
              label: v.value,
              value: v.value,
            });
            this.paramsForm.unit = v.value;
          } else {
            this.$message.warning(this.$t("lang.editVar.msg27"));
          }
        });
      } else {
        this.paramsForm.unit = e.toString();
      }
    },
    intervalChange(e) {
      if (e == "自定义") {
        this.$prompt(
          this.$t("lang.editVar.msg21"),
          this.$t("lang.editVar.msg22"),
          {
            confirmButtonText: this.$t("lang.editVar.msg23"),
            cancelButtonText: this.$t("lang.editVar.msg24"),
            inputPattern: /^[0-9].*$/,
            inputErrorMessage: this.$t("lang.editVar.msg25"),
          }
        )
          .then(({ value }) => {
            if (!this.intervalOptions.some((v) => v.value == value)) {
              this.intervalOptions.pop();
              this.intervalOptions.push({
                label: value,
                value,
              });
              this.intervalOptions.push({
                label: this.$t("lang.editVar.msg26"),
                value: "自定义",
              });
            }
            this.paramsForm.interval = value;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("lang.editVar.msg27"),
            });
            this.paramsForm.interval = 10;
          });
      }
    },
    typeChange(e) {
      this.paramsForm.ioType = e;
      this.paramsForm.funcType = "0";
    },
    functypeChange(e) {
      this.paramsForm.funcType = e;
      if (this.templateType == "0") {
        if (e == 1) {
          this.paramsForm.unit = "1";
        } else if (e == 2) {
          this.paramsForm.unit = "4";
        }
      } else {
        this.paramsForm.unit = "0";
      }
    },
    ioNumberChange(e) {
      this.paramsForm.ioNumber = e;
    },
    isAlterChange(e) {
      this.paramsForm.isAlter = e;
    },
  },
  //监听函数
  watch: {
    "paramsForm.ioType": {
      handler(newValue, oldValue) {
        if (this.templateType == 1) {
          this.ioNumberList = [];
          this.ioNumberList.push({
            label: ioTypeObj[newValue] + "1",
            value: "1",
          });
          this.$set(this.ioNumberObj, "1", ioTypeObj[newValue] + "1");
          if (newValue == 0) {
            this.ioNumberList.push({
              label: ioTypeObj[newValue] + "2",
              value: "2",
            });
            this.$set(this.ioNumberObj, "2", ioTypeObj[newValue] + "2");
          }
          this.isAlterList = [];
          try {
            switch (newValue.toString()) {
              case "0":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.readandwrite"),
                  value: "1",
                });
                this.$set(
                  this.isAlterObj,
                  "1",
                  this.$t("lang.editVar.readandwrite")
                );
                this.paramsForm.isAlter = "1";
                break;
              case "1":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.read"),
                  value: "0",
                });
                this.$set(this.isAlterObj, "0", this.$t("lang.editVar.read"));
                this.paramsForm.isAlter = "0";
                break;
              case "2":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.readandwrite"),
                  value: "1",
                });
                this.$set(
                  this.isAlterObj,
                  "1",
                  this.$t("lang.editVar.readandwrite")
                );
                this.paramsForm.isAlter = "1";
                break;
            }
          } catch (err) { }
        }
      },
      immediate: true,
    },
    "paramsForm.registerType": {
      handler(newValue, oldValue) {
        if (this.templateType == 0) {
          this.isAlterList = [];
          try {
            switch (newValue.toString()) {
              case "1":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.readandwrite"),
                  value: "1",
                });
                this.$set(
                  this.isAlterObj,
                  "1",
                  this.$t("lang.editVar.readandwrite")
                );
                this.paramsForm.isAlter = "1";
                break;
              case "2":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.read"),
                  value: "0",
                });
                this.$set(this.isAlterObj, "0", this.$t("lang.editVar.read"));
                this.paramsForm.isAlter = "0";
                break;
              case "3":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.readandwrite"),
                  value: "1",
                });
                this.$set(
                  this.isAlterObj,
                  "1",
                  this.$t("lang.editVar.readandwrite")
                );
                this.paramsForm.isAlter = "1";
                break;
              case "4":
                this.isAlterList.push({
                  label: this.$t("lang.editVar.read"),
                  value: "0",
                });
                this.$set(this.isAlterObj, "0", this.$t("lang.editVar.read"));
                this.paramsForm.isAlter = "0";
                break;
            }
          } catch (err) { }
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}

.params-form {
  display: flex;
  justify-content: center;
}
</style>
